import React from "react";
import { Patient } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";
import { StatusLabel } from "@shared/components";
import { STATUS } from "@shared/constants";
import { getFullName } from "@shared/utils";

export const patientTableProperties: TableProperty<Patient>[] = [
  {
    title: "Name",
    key: "first_name",
    get: (item) => getFullName(item),
    sort: ["first_name", "last_name"],
  },
  {
    title: "Gender",
    key: "gender",
    get: (item) => item.gender,
    sort: ["gender"],
  },
  {
    title: "Age",
    key: "age",
    get: (item) => item.age,
    sort: ["age"],
  },
  {
    title: "Email Address",
    key: "email",
    get: (item) => item.email,
    sort: ["email"],
  },
  {
    title: "Phone Number",
    key: "phone",
    get: (item) => item.phone,
    sort: ["phone"],
  },
  {
    title: "Assigned Staff",
    key: "assigned_users",
    get: (item) => item.assigned_users.map(getFullName).join(",\r\n"),
  },
  {
    title: "Status",
    key: "is_active",
    get: (item) => (
      <StatusLabel
        text={item.is_active ? STATUS.ACTIVE : STATUS.INACTIVE}
        textStatus={item.is_active ? STATUS.ACTIVE : STATUS.INACTIVE}
      />
    ),
    sort: ["is_active"],
  },
];
